import { ReactNode } from "react";
import { Link } from "react-router-dom";

export default function KpiCard({
  label,
  value,
  hint,
  icon,
  accent = "brand",
  to,
}: {
  label: string;
  value: ReactNode;
  hint?: string;
  icon?: ReactNode;
  accent?: "brand" | "amber" | "red" | "blue" | "slate";
  /** If set, the card becomes a link to this path. */
  to?: string;
}) {
  const accentMap: Record<string, string> = {
    brand: "bg-brand-50 text-brand-700",
    amber: "bg-amber-50 text-amber-700",
    red: "bg-red-50 text-red-700",
    blue: "bg-blue-50 text-blue-700",
    slate: "bg-slate-100 text-slate-700",
  };

  const inner = (
    <div className="flex items-start justify-between gap-3">
      <div>
        <p className="text-xs font-medium text-slate-500 uppercase tracking-wide">{label}</p>
        <p className="text-3xl font-semibold text-slate-900 mt-1">{value}</p>
        {hint && <p className="text-xs text-slate-500 mt-1">{hint}</p>}
      </div>
      {icon && <div className={`p-2 rounded-lg ${accentMap[accent]}`}>{icon}</div>}
    </div>
  );

  if (to) {
    return (
      <Link
        to={to}
        className="card p-5 hover:border-brand-500 hover:shadow transition cursor-pointer block"
      >
        {inner}
      </Link>
    );
  }
  return <div className="card p-5">{inner}</div>;
}
